export default "__VITE_ASSET__0611169a__"